module.exports = __webpack_public_path__ + "img/logo.bef6bb2c.png";